import { IAvailableStore, IStore } from '../types';

export const formatStores = (stores: IStore[]): IAvailableStore[] =>
    stores.map((store) => ({
        id: store.u_smd_sapnr,
        lat: parseFloat(store.u_smd_lat),
        lng: parseFloat(store.u_smd_lon),
        address: `${store.u_smd_address} ${store.u_smd_addressnumber}`,
        postalCode: store.u_smd_postalcode,
        city: store.u_smd_city,
        storeUrl: store.u_smd_urlstore,
        storeAppointmentUrl: store.u_smd_urlstoreappointment,
        storeName: store.u_smd_storename.split('-')[0],
        storeNote: store.u_smd_storenote,
        specialHours: store.u_smd_gmbspecialhours,
        phone: store.u_smd_phone,
        openingHours: [
            // Align array index with day of the week according to the javascritp Date object
            // 0 = sunday, 1 = monday etc.
            { dayName: 'Zondag', hours: store.u_smd_sal_sunday },
            { dayName: 'Maandag', hours: store.u_smd_sal_monday },
            { dayName: 'Dinsdag', hours: store.u_smd_sal_tuesday },
            { dayName: 'Woensdag', hours: store.u_smd_sal_wednesday },
            { dayName: 'Donderdag', hours: store.u_smd_sal_thursday },
            { dayName: 'Vrijdag', hours: store.u_smd_sal_friday },
            { dayName: 'Zaterdag', hours: store.u_smd_sal_saturday },
        ],
    }));
